import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import IMAGES from '../../const/images';
import { Header } from '../../components/Onboarding/Header';
import { Footer } from '../../components/Onboarding/Footer';
import ConfirmForm from '../../components/ResetPassword/ConfirmForm';

const { Title, Text } = Typography;

const ConfirmPasswordScreen = () => {
    const { t } = useTranslation('login');

    return (
        <div
            style={{ backgroundImage: `url(${IMAGES.login.spirals})` }}
            className="public-layout"
        >
            <div className="public-layout__container">
                <div className="public-layout__container--form">
                    <Space direction="vertical" size={28}>
                        <Header />
                        <Title level={2} style={{ color: 'var(--color-purple)', marginBottom: 0 }}>
                            { t('CONFIRM_PASSWORD') }
                        </Title>
                        <Text>
                            { t('CONFIRM_PASSWORD_HELP')}
                        </Text>
                        <Space direction="vertical" size={24}>
                            <ConfirmForm />
                        </Space>
                        <Footer />
                    </Space>
                </div>
            </div>
        </div>
    );
};

export { ConfirmPasswordScreen };
